import React from 'react';
import PropTypes from 'prop-types';

const Alert = ({ children, alertVariantClass, alertIconClass }) => {
	return (
		<div className={`alert ${alertVariantClass} d-flex`}>
			<i
				className={`ddc-icon ${alertIconClass} mr-3`}
				aria-hidden="true"
			/>
			{children}
		</div>
	);
};

Alert.propTypes = {
	children: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
		.isRequired,
	alertVariantClass: PropTypes.string.isRequired,
	alertIconClass: PropTypes.string.isRequired
};

export default Alert;
